/**
 * THE code-level feature flags - one function per feature, one place to flip.
 *
 * These are deliberately NOT environment variables. A flag here is a decision
 * about where a feature is ready, not about how a box is configured, and it
 * ships and reverts with the code that reads it.
 *
 * Everything region-shaped asks `region.ts` (the same `isEU()` the sidebar's
 * hidden-path sets use) rather than reading the hostname again.
 */
import { isEU, isDev } from './region';

/**
 * AI usage - the per-item usage panes and the two Settings usage sections.
 *
 * TEMPORARILY OFF ON EU. The readout is about to be enhanced, and until that
 * lands EU should behave as though the feature does not exist yet: no fetch,
 * no pane, no rail pill, no settings entry. Every AI-usage surface - the
 * fetch hooks, the four detail-page surfaces, the side panel and the settings
 * registry - checks THIS function, so there is exactly one thing to change.
 *
 * TO ENABLE ON EU: delete the `!isEU()` below and return `true`.
 */
export const isAiUsageEnabled = (): boolean => !isEU();

/**
 * Email assistant - the Outlook propose-and-send reply feature (watch a contact
 * or thread, draft a reply for approval, progressing toward guarded automation).
 *
 * DEV/DEMO ONLY for now. It touches privileged client mail and auto-send is
 * compliance-gated (see docs/email-assistant-and-eml-plan.md §A-4), so it must
 * NOT appear on EU/production until counsel sign-off and the automation ladder
 * are in place. Keyed to `isDev()` so it is live on dev.pons.io / demo.pons.io
 * and off everywhere else, EU included. Every assistant surface checks THIS
 * function, so there is exactly one place to widen it later.
 *
 * TO ENABLE BEYOND DEV: change the gate here (and only here).
 */
export const isEmailAssistantEnabled = (): boolean => isDev();
